var map = {
	"./Home": [
		8708,
		708
	],
	"./Home/": [
		8708,
		708
	],
	"./Home/index": [
		8708,
		708
	],
	"./Home/index.tsx": [
		8708,
		708
	],
	"./PrivacyPolicy": [
		4444,
		444
	],
	"./PrivacyPolicy/": [
		4444,
		444
	],
	"./PrivacyPolicy/index": [
		4444,
		444
	],
	"./PrivacyPolicy/index.tsx": [
		4444,
		444
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;